(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/favorites/assets/javascripts/views/editmatchfavorites.js') >= 0) return;  svs.modules.push('/components/sport/favorites/assets/javascripts/views/editmatchfavorites.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs.components = svs.components || {};
  svs.components.views = svs.components.views || {};

  svs.components.views.EditMatchFavorites = Backbone.View.extend({
    options: {
      classId: 'EditMatchFavorites'
    },
    tagName: 'div',
    events: {
      'click label[data-favorite]': 'toggleFavorite'
    },
    initialize: function() {
      this.render();
    },
    render: function() {
      var league;

      if (this.options.match.leagueId) {
        league = {
          id: this.options.match.leagueId,
          name: this.options.match.leagueName,
          isFavorite: Boolean(this.options.favorites.leagues.findWhere({
            LeagueId: this.options.match.leagueId
          })),
          country: { isoCode: this.options.match.isoCode }
        };
      }

      var favoriteData = {
        homeTeam: {
          id: this.options.match.homeTeamId,
          name: this.options.match.homeTeamName,
          isFavorite: Boolean(this.options.favorites.teams.findWhere({
            TeamId: this.options.match.homeTeamId
          }))
        },
        awayTeam: {
          id: this.options.match.awayTeamId,
          name: this.options.match.awayTeamName,
          isFavorite: Boolean(this.options.favorites.teams.findWhere({
            TeamId: this.options.match.awayTeamId
          }))
        },
        league: league
      };
      favoriteData.checkboxStyle =
        this.options.checkboxstyle || 'btn-toggle-sportservice';
      this.$el.html(
        svs.sport.favorites.templates.editmatchfavorites(favoriteData)
      );

      this.$el[0].offsetHeight; 
    },
    toggleFavorite: function(e) {
      e.preventDefault();
      var favoriteModel;
      switch ($(e.currentTarget).data('favorite')) {
        case 'homeTeam':
          if (
            this.options.favorites.teams.findWhere({
              TeamId: this.options.match.homeTeamId
            })
          ) {
            favoriteModel = this.options.favorites.teams.findWhere({
              TeamId: this.options.match.homeTeamId
            });
            this.options.favorites.teams.remove(favoriteModel);
          } else {
            this.options.favorites.teams.add(
              new this.options.favorites.teams.model({
                favoriteOrder: this.options.favorites.teams.length,
                TeamId: parseInt(this.options.match.homeTeamId, 10)
              })
            );
          }
          break;
        case 'awayTeam':
          if (
            this.options.favorites.teams.findWhere({
              TeamId: this.options.match.awayTeamId
            })
          ) {
            favoriteModel = this.options.favorites.teams.findWhere({
              TeamId: this.options.match.awayTeamId
            });
            this.options.favorites.teams.remove(favoriteModel);
          } else {
            this.options.favorites.teams.add(
              new this.options.favorites.teams.model({
                favoriteOrder: this.options.favorites.teams.length,
                TeamId: parseInt(this.options.match.awayTeamId, 10)
              })
            );
          }
          break;
        case 'league':
          if (
            this.options.favorites.leagues.findWhere({
              LeagueId: this.options.match.leagueId
            })
          ) {
            favoriteModel = this.options.favorites.leagues.findWhere({
              LeagueId: this.options.match.leagueId
            });
            this.options.favorites.leagues.remove(favoriteModel);
          } else {
            this.options.favorites.leagues.add(
              new this.options.favorites.leagues.model({
                favoriteOrder: this.options.favorites.leagues.length,
                LeagueId: this.options.match.leagueId
              })
            );
          }
          break;
        default:
      }
      this.render();
    }
  });
})(Backbone, _, svs);

 })(window);